import React from "react";
import { Card, Row, Col, CardTitle, CardBody, CardFooter } from "reactstrap";
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';
const DiscussionThread = ({ messages }) => {
  return (
    
    <div className="discussion-thread">
      
      <CardTitle tag="h5" style={{ paddingLeft: "10px", paddingTop: 10 }}>
        Fil de discussion
      </CardTitle>
      <div className="chat-conversation p-3">

        <SimpleBar>
          <ul className="list-unstyled mb-0">
            {
              messages && (messages || []).map((message, index) => {
                if (message.type === "message") {

                  return (
                    <li
                      key={index}
                      className={
                        message.position == "right" ? "right" : ""
                      }
                    >
                      <div className="conversation-list" style={{ width: "45%" }}>
                        <div className="ctext-wrap" style={{ textAlign: "left" }}>
                          <div className="conversation-name">
                            {message.head.sil} - {message.head.role}
                          </div>
                          <p dangerouslySetInnerHTML={{ __html: message.body }} />
                          {message.footer && <a
                            href={message.footer}
                            style={{ fontSize: 25 }}
                            className="bx bx-download"
                          ></a>}
                          <p className="chat-time mb-0"><i className="bx bx-time-five align-middle me-1"></i>{message?.head?.created_at}</p>
                        </div>
                      </div>
                    </li>
                  )
                } else {
                  return (
                    <li
                      key={index}
                      className="right"
                    >
                      <div className="conversation-list" style={{ width: "100%" }}>
                        <div className="ctext-wrap pb-0 bg-success-subtle" style={{ textAlign: "left" }}>
                          <div
                            className="d-flex justify-content-between"
                          >
                            <p>{message.body.text}</p>
                            {message.images && <img src={message.images} alt="" width="150px" />}
                            <p className="chat-time"><i className="bx bx-time-five align-middle me-1 pb-1"></i>{message.body.date}</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  )
                }
              })
            }
          </ul>
        </SimpleBar>
      </div>
    </div>
  );
};

export default DiscussionThread;
